import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";

export const ResmanCredentialForm = ({ register }: CredentialFormProps) => (
  <>
    <BaseInput
      id="resman_partner_id"
      label="Integration Partner ID"
      {...register("resman_partner_id")}
      required
    />
    <BaseInput
      id="resman_account_id"
      label="Account ID"
      {...register("resman_account_id")}
      required
    />
    <BaseInput
      id="resman_api_key"
      label="API Key"
      {...register("resman_api_key")}
      required
    />
  </>
);
